import { render, staticRenderFns } from "./TheWellboreIntervalElements.vue?vue&type=template&id=ed2d793a"
import script from "./TheWellboreIntervalElements.vue?vue&type=script&lang=ts"
export * from "./TheWellboreIntervalElements.vue?vue&type=script&lang=ts"
import style0 from "./TheWellboreIntervalElements.vue?vue&type=style&index=0&id=ed2d793a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports